
const getPlayersStatistic = (eventMapAdded, eventMapDeleted, players) => {
    console.log("EventAdded", eventMapAdded);
    console.log("EventDeleted", eventMapDeleted);


    let statistics = {}

    if (eventMapAdded instanceof Object) {
        Object.keys(eventMapAdded).forEach(key => {
            const event = eventMapAdded[key];

            const player = players.find(item => item.uid === event.playerUid)
            if (player) {
                if (!statistics[event.playerUid]) {
                    statistics[event.playerUid] = Object.assign({}, player.statistic || {});
                }
                statistics[event.playerUid] = getPlayerStatistic(statistics[event.playerUid], event, 1);
            }
        })
    }

    if (eventMapDeleted instanceof Object) {
        Object.keys(eventMapDeleted).forEach(key => {
            const event = eventMapDeleted[key];

            const player = players.find(item => item.uid === event.playerUid)
            if (player) {
                if (!statistics[event.playerUid]) {
                    statistics[event.playerUid] = Object.assign({}, player.statistic || {});
                }
                statistics[event.playerUid] = getPlayerStatistic(statistics[event.playerUid], event, -1);
            }
        })
    }

    console.log("PlayersStatistics", statistics);
    return statistics;
}

const getPlayerStatistic = (playerStat, event, value) => {

    let playerStatistic = Object.assign({}, playerStat || {});
    switch (event.event) {
        case 'gol': playerStatistic.goals = (playerStatistic.goals || 0) + value; break;
        case 'auto_gol': playerStatistic.autoGoals = (playerStatistic.autoGoals || 0) + value; break;
        case 'yellow_card': playerStatistic.yellowCards = (playerStatistic.yellowCards || 0) + value; break;
        case 'red_card': playerStatistic.redCards = (playerStatistic.redCards || 0) + value; break;
        case 'valla_invicta': playerStatistic.vallasInvictas = (playerStatistic.vallasInvictas || 0) + value; break;
        default: break;
    }

    return playerStatistic;
}

export { getPlayersStatistic };

